import { render, staticRenderFns } from "./CreateRiskCategory.vue?vue&type=template&id=c98c2e16&"
import script from "./CreateRiskCategory.vue?vue&type=script&lang=js&"
export * from "./CreateRiskCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports